import {
  addFormControlSelect2,
  fnErrorMsg,
  fnToastrFormError,
  printResponse,
  resetForm,
} from "../jquery-functions-library";
import { element_exists, redesignDataTablesHeader } from "../functions";

export var fnDatatableCompanies = function() {
  const tableName = "#datatable-companies";
  if (!element_exists(tableName) || $.fn.dataTable.isDataTable(tableName)) {
    return false;
  }

  $.ajaxSetup({ headers: { "X-CSRF-TOKEN": $('[name="_token"]').val() } });

  $(tableName).css("width", "100%");

  //Load language
  var t = $(tableName).DataTable({
    language: allLangFiles.datatables,

    //url for the update function
    ajax: "/companies/update-companies-table",
    rowId: "id",

    /*Rules for filling the columns*/
    columns: [
      { data: "id" },
      {
        data: "name",
        render: function(data, type, row) {
          if (row.deactivated_at) {
            return data + " (" + allLangFiles.companies.deactivated + ")";
          }
          return data;
        },
      },
      { data: "cvr" },
      { data: "address" },
      { data: "economic_data.economic_number" },
      { data: "economic_data.customer_no" },
      {
        data: "services.num_of_vouchers",
        render: function(data, type, row) {
          return data == 0 ? "N/A" : data;
        },
      },
      { data: "services.fixed_price" },
      { data: "vat_frequency_text" },
      { data: "update_frequency_text" },
    ],
    createdRow: function(row, data, dataIndex) {
      if (data.deleted_at) {
        $(row).addClass("deleted_company");
      }
    },
    scrollX: true,
    initComplete: function(settings, json) {},
  });

  var table = $(tableName).DataTable();

  const { $filterButtons } = redesignDataTablesHeader(tableName, true, null);
  $filterButtons.prepend($("#btn-open-create-company"));

  var accounts = [];
  var form = $("#form-create-company");
  var modal = $("#modal-create-company");

  let $dayFrequency = $('select[name="day_frequency[]"]');
  let $services = $('select[name="services[]"]');

  $dayFrequency.select2({ width: "100%" }).trigger("change");
  $services.select2({ width: "100%" }).trigger("change");

  $("#datatable-companies tbody").off("click", "tr");
  $("#datatable-companies tbody").on("click", "tr", function() {
    resetActiveTab();
    var tableData = table.row(this).data();

    if (table.row(this).data().services.num_of_vouchers == "0") {
      table.row(this).data().services.num_of_vouchers = "N/A";
    }

    //Hot fix
    //https://stackoverflow.com/questions/20964811/replace-amp-to-lt-to-and-gt-to-gt-in-javascript?lq=1
    tableData.name = $("<textarea></textarea>")
      .html(tableData.name)
      .text();

    createCompanyForm(tableData, modal, function(economicAccounts) {
      accounts = economicAccounts;
    });
    $dayFrequency.trigger("change");
    $services.trigger("change");
    modal.modal("show");
  });

  /*Delete method*/
  $("#modal-btn-delete-company")
    .off("click")
    .on("click", function() {
      var infoModal = $("#modal-info");
      var id = form.find("input[name=id]").val();

      infoModal.find(".modal-body").html("");

      var lang = allLangFiles.companies.js;

      $.confirm({
        title: lang.delete.title,
        content: lang.delete.content,
        theme: "supervan",
        columnClass: "col-md-12",
        backgroundDismiss: true,
        buttons: {
          Ja: {
            action: function() {
              $.ajax({
                method: "POST",
                data: {
                  id: id,
                },
                url: "/companies/delete",
                success: function(response) {
                  printResponse(response);
                  $("#datatable-companies")
                    .DataTable()
                    .ajax.reload(null, false);

                  reloadCompaniesSelect(response);
                },
                error: fnErrorMsg,
              });
            },
            text: lang.yes,
          },
          Nej: {
            text: lang.no,
          },
        },
      });
    });

  $("#modal-btn-restore-company")
    .off("click")
    .on("click", function() {
      var infoModal = $("#modal-info");
      var id = form.find("input[name=id]").val();

      infoModal.find(".modal-body").html("");

      var lang = allLangFiles.companies.js;

      $.confirm({
        title: lang.restore.title,
        content: lang.restore.content,
        theme: "supervan",
        columnClass: "col-md-12",
        backgroundDismiss: true,
        buttons: {
          Ja: {
            action: function() {
              $.ajax({
                method: "POST",
                data: {
                  id: id,
                },
                url: "/companies/restore",
                success: function(response) {
                  printResponse(response);
                  $("#datatable-companies")
                    .DataTable()
                    .ajax.reload(null, false);
                  reloadCompaniesSelect(response);
                },
                error: fnErrorMsg,
              });
            },
            text: lang.yes,
          },
          Nej: {
            text: lang.no,
          },
        },
      });
    });

  $("#modal-btn-deactivate-company")
    .off("click")
    .on("click", function() {
      var infoModal = $("#modal-info");
      var id = form.find("input[name=id]").val();

      infoModal.find(".modal-body").html("");

      var lang = allLangFiles.companies.js;

      $.confirm({
        title: lang.deactivate.title,
        content: lang.deactivate.content,
        theme: "supervan",
        columnClass: "col-md-12",
        backgroundDismiss: true,
        buttons: {
          Ja: {
            action: function() {
              $.ajax({
                method: "POST",
                data: {
                  id: id,
                },
                url: "/companies/deactivate",
                success: function(response) {
                  printResponse(response);
                  $("#datatable-companies")
                    .DataTable()
                    .ajax.reload(null, false);
                  reloadCompaniesSelect(response);
                },
                error: fnErrorMsg,
              });
            },
            text: lang.yes,
          },
          Nej: {
            text: lang.no,
          },
        },
      });
    });

  $("#modal-btn-activate-company")
    .off("click")
    .on("click", function() {
      var infoModal = $("#modal-info");
      var id = form.find("input[name=id]").val();

      infoModal.find(".modal-body").html("");

      var lang = allLangFiles.companies.js;

      $.confirm({
        title: lang.activate.title,
        content: lang.activate.content,
        theme: "supervan",
        columnClass: "col-md-12",
        backgroundDismiss: true,
        buttons: {
          Ja: {
            action: function() {
              $.ajax({
                method: "POST",
                data: {
                  id: id,
                },
                url: "/companies/activate",
                success: function(response) {
                  printResponse(response);
                  $("#datatable-companies")
                    .DataTable()
                    .ajax.reload(null, false);
                  reloadCompaniesSelect(response);
                },
                error: fnErrorMsg,
              });
            },
            text: lang.yes,
          },
          Nej: {
            text: lang.no,
          },
        },
      });
    });

  /*Reset all values in form when closing to avoid filled files when action goes: table->create*/
  modal.on("hidden.bs.modal", function() {
    resetFormModal(form);
    $('#kube_data_field_id option[value="NULL"]').prop("selected", true);
    $('select[name="employee_default_id"]').empty();
    $('select[name="assistant_id"]').empty();
    $('select[name="day_frequency[]"]')
      .val("")
      .trigger("change");
    $('select[name="services[]"]')
      .val("")
      .trigger("change");
  });

  /*Make ajax call on submit */
  $("#form-create-company")
    .off("submit")
    .on("submit", function(e) {
      e.preventDefault();
      /*TODO Clean up, maybe create a second modal*/
      var url = "";
      var data = $(this).serializeArray();

      var update =
        $("#form-create-company")
          .find("#modal-btn-delete-company")
          .is(":visible") ||
        $("#form-create-company")
          .find("#modal-btn-restore-company")
          .is(":visible");

      if (update) {
        url = "/companies/update";
      } else {
        url = "/companies/create";
      }

      $.ajax({
        method: "POST",
        url: url,
        /*Convert to json otherwise laravel doesn't recognise the account objects*/
        data: data,
        success: function(response) {
          $("#datatable-companies")
            .DataTable()
            .ajax.reload(null, false);
          modal.modal("hide");
        },
        error: fnToastrFormError,
      });
    });

  $(".accounts-toggle-select").on("click", function(e) {
    $(this)
      .parents()
      .find("#form-create-company")
      .find('input[name^="economic_accounts"]')
      .prop("checked", this.checked);
  });

  $("form input").on("invalid", function() {
    modal.find(".nav-item .nav-link").removeClass("active");
    modal.find(".tab-content .tab-pane").removeClass("active");
    var tab = $(this).closest(".tab-content .tab-pane");
    var id = tab.addClass("active").attr("id");
    $("." + id).addClass("active");
  });

  $("#btn-load-api-data")
    .off("click")
    .on("click", function(e) {
      e.preventDefault();

      var endpoint = $("#endpoint").val();
      var value = $("#api_token").val();

      if (endpoint == "") return;
      else if (endpoint == "economic") endpoint = "/companies/endpoint";
      loadApiData(endpoint, value);
    });

  function resetActiveTab() {
    modal.find(".nav-item .nav-link").removeClass("active");
    modal.find(".tab-content .tab-pane").removeClass("active");
    $(".setup-tab").addClass("active");
    $("#setup-tab").addClass("active");
  }

  function loadEmploymentData() {
    $.ajax({
      type: "GET",
      url: "/getAllKeepersEmployees",
      success: function(response) {
        //Primary employee data
        var defaultEmployeeElement = $('select[name="employee_default_id"]');
        var lblDefaultEmployeeElement = $('label[for="employee_default_id"]');

        defaultEmployeeElement.empty();
        defaultEmployeeElement.show();
        lblDefaultEmployeeElement.show();

        $.each(response, function(k, v) {
          defaultEmployeeElement.append(
            '<option value="' + v.id + '">' + v.name + "</option>"
          );
        });
        defaultEmployeeElement.val("");

        //Assistant data
        var assistantElement = $('select[name="assistant_id"]');
        var lblAssistantElement = $('label[for="assistant_id"]');

        assistantElement.empty();
        assistantElement.show();
        lblAssistantElement.show();

        $.each(response, function(k, v) {
          assistantElement.append(
            '<option value="' + v.id + '">' + v.name + "</option>"
          );
        });
        assistantElement.val("");
      },
      error: fnErrorMsg,
    });
  }

  function loadClientData() {
    $.ajax({
      type: "GET",
      url: "/getAllKeepersEmployees",
      success: function(response) {
        //Approver 1 data
        var approver1 = $('select[name="approver_1"]');
        var approver1Label = $('label[for="approver_1"]');

        approver1.empty();
        approver1.show();

        $.each(response, function(k, v) {
          approver1.append(
            '<option value="' + v.id + '">' + v.name + "</option>"
          );
        });

        // Approver 2 data
        var approver2 = $('select[name="approver_2"]');
        var approver2Label = $('label[for="approver_2"]');

        approver2.empty();
        approver2.show();

        $.each(response, function(k, v) {
          approver2.append(
            '<option value="' + v.id + '">' + v.name + "</option>"
          );
        });

        if (typeof data !== 'undefined') {
          getCurrentApprovers(data.id);
        }
      },
      error: fnErrorMsg,
    });
  }

  window.getCurrentApprovers = function(id) {
    $.ajax({
      type: "GET",
      url: `${id}/getCurrentApprovers`,
      success: function(response) {
        //Approver 1 data
        var approver1 = $('select[name="approver_1"]');
        approver1.val(
          response["first_approver_id"] ? response["first_approver_id"] : ""
        );

        //Approver 2 data
        var approver2 = $('select[name="approver_2"]');
        approver2.val(
          response["next_approver_id"] ? response["next_approver_id"] : ""
        );

        
        if(response["first_approver_id"]) {
            $('.salary_two_step_approval_container').removeClass("hidden");
        }
      },
      error: fnErrorMsg,
    });
  };

  $("#btn-open-create-company")
    .off("click")
    .on("click", function(e) {
      $(".accounts-tab").addClass("hidden");
      resetActiveTab();
      $('option[value="0"]').prop("selected", true);
      $('option[value=""]').prop("selected", true);
      $(
        'label[for="employee_default_id"],select[name="employee_default_id"]'
      ).hide();
      $('label[for="assistant_id"],select[name="assistant_id"]').hide();
      var kube = "NULL";
      loadKubeData(kube);
      loadEmploymentData();
      loadClientData();
      loadOutlayDetails({ id: null }, modal);
      form.find("#has_roger_ai").val("1"); /*Default roger to one*/
    });
};

function loadKubeData(value) {
  $.ajax({
    url: "/kube/load-options",
    success: function(response) {
      var options = response.kubeDataFieldOptions;
      var html = "";
      $.each(options, function(k, v) {
        var selected = "";
        if (value == k) {
          selected = "selected";
        }
        html += '<option value="' + k + '" ' + selected + ">" + v + "</option>";
      });
      html += "</div>";
      $("#kube_data_field_id").html(html);
    },
    error: fnErrorMsg,
  });
}

function loadApiData(endpoint, value) {
  $.ajaxSetup({
    headers: { "X-CSRF-TOKEN": $('meta[name="csrf-token"]').attr("content") },
  });
  $.ajax({
    type: "POST",
    url: endpoint,
    data: { api_token: value },
    success: function(response) {
      $.each(response.data, function(k, v) {
        //display the key and value pair
        if (v !== null) {
          $("#modal-create-company")
            .find('input[name="' + k + '"]')
            .val(v);
        }
        if (k == "economicData") {
          $.each(v, function (k, v) {
            if (k == "currency") {
              $("#modal-create-company")
                .find('input[name="' + k + '"]')
                .val(v.baseCurrency);
            } else {
              $("#modal-create-company")
                .find('input[name="' + k + '"]')
                .val(v);
            }
          });
        }
      });
    },
    error: fnToastrFormError,
  });
}

function createCompanyForm(data, element, callback) {
  /*resetForm($('#form-create-company'));*/
  $("#accounts-container").html("");

  var url = "/voucher/account/all/" + data.id;

  $.ajax({
    type: "GET",
    url: `/companies/${data.id}/keepers-employees`,
    success: function(response) {
      //Primary employee data
      var employeeDefaultId = data.employee_default_id;
      var defaultEmployeeElement = $('select[name="employee_default_id"]');
      var lblDefaultEmployeeElement = $('label[for="employee_default_id"]');

      defaultEmployeeElement.empty();
      defaultEmployeeElement.show();
      lblDefaultEmployeeElement.show();

      $.each(response, function(k, v) {
        defaultEmployeeElement.append(
          '<option value="' + v.id + '">' + v.name + "</option>"
        );
      });
      defaultEmployeeElement.val(employeeDefaultId);

      //Assistant data
      var assistantId = data.assistant_id;
      var assistantElement = $('select[name="assistant_id"]');
      var lblAssistantElement = $('label[for="assistant_id"]');

      assistantElement.empty();
      assistantElement.show();
      lblAssistantElement.show();

      $.each(response, function(k, v) {
        assistantElement.append(
          '<option value="' + v.id + '">' + v.name + "</option>"
        );
      });
      assistantElement.val(assistantId);
    },
    error: fnErrorMsg,
  });

  $.ajax({
    url: url,
    data: $(this).serialize(),
    success: function(response) {
      var accounts = response.databaseData;
      var permission =
        $("#accounts-permission").data("permission") === "readonly"
          ? "disabled"
          : "";
      callback(accounts);

      var html = "";
      $.each(accounts, function(k, v) {
        var checked = "";

        if (v.approved_post === 1) {
          checked = "checked";
        }
        html +=
          '<span class="bmd-form-group is-filled"><div class="checkbox checkbox-primary"><label><input name="economic_accounts[]" value="' +
          v.id +
          '" type="checkbox" ' +
          checked +
          " " +
          permission +
          '><span class="checkbox-decorator"><span class="check"></span></span>' +
          v.accountNumber +
          " - " +
          v.name +
          "</label></div></span>";
      });
      html += "</div>";
      html +=
        '<input type="hidden" value="" name="economic_accounts[]">'; /*Hack - add this to ensure that we know whether it finished loading*/
      $("#accounts-container").html(html);
    },
    error: fnErrorMsg,
  });

  $.ajax({
    type: "GET",
    url: `${data.id}/getAllCompanyClients`,
    success: function(response) {
      //Approver 1 data
      var approver1 = $('select[name="approver_1"]');
      var approver1Label = $('label[for="approver_1"]');

      approver1.empty();
      approver1.show();

      $.each(response, function(k, v) {
        approver1.append(
          '<option value="' + v.id + '">' + v.name + "</option>"
        );
      });

      // Approver 2 data
      var approver2 = $('select[name="approver_2"]');
      var approver2Label = $('label[for="approver_2"]');

      approver2.empty();
      approver2.show();

      $.each(response, function(k, v) {
        approver2.append(
          '<option value="' + v.id + '">' + v.name + "</option>"
        );
      });

      getCurrentApprovers(data.id);
    },
    error: fnErrorMsg,
  });

  loadOutlayDetails(data, element);

  let servicesValue = [];
  let $services = $('select[name="services[]"]');

  $.each(data, function(k, v) {
    //display the key and value pair
    element.find('[name="' + k + '"]').val(v);
    if (k == "services" || k == "economic_data") {
      $.each(v, function(k, v) {
        element.find("#" + k).val(v);

        if ($services.find('option[value="' + k + '"]').length > 0 && v == 1) {
          servicesValue.push(k);
        }
      });
    }
  });
  $services.val(servicesValue);

  element.find(".form-group.bmd-form-group").addClass("is-filled");
  if (data.deleted_at) {
    $("#form-create-company")
      .find("#modal-btn-restore-company")
      .removeClass("hidden");
  } else {
    $("#form-create-company")
      .find("#modal-btn-delete-company")
      .removeClass("hidden");

    if (data.deactivated_at) {
      $("#form-create-company")
        .find("#modal-btn-activate-company")
        .removeClass("hidden");
    } else {
      $("#form-create-company")
        .find("#modal-btn-deactivate-company")
        .removeClass("hidden");
    }
  }

  var lang = allLangFiles.companies.js;

  $("#modal-save-company").html(lang.update);
  $(".modal-title").html(lang.update + " " + data.name);

  var kube = "NULL";
  if (data.services && data.services.kube_data_field_id) {
    kube = data.services.kube_data_field_id;
  }

  if (
    data.api_token == data.economic_data.economic_token &&
    data.api_token != null
  ) {
    $("#endpoint")
      .find('option:contains("E-conomic")')
      .prop("selected", true);
  }
  loadKubeData(kube);
}

function resetFormModal(form) {
  resetForm(form);

  var lang = allLangFiles.companies.js;

  $("#modal-save-company").html(lang.create);
  $(".modal-title").html(lang.company_create);
  $("#form-create-company")
    .find("#modal-btn-delete-company")
    .addClass("hidden");
  $("#form-create-company")
    .find("#modal-btn-restore-company")
    .addClass("hidden");
  $("#form-create-company")
    .find("#modal-btn-deactivate-company")
    .addClass("hidden");
  $("#form-create-company")
    .find("#modal-btn-activate-company")
    .addClass("hidden");
  $("#accounts-container").html("");
  $(".accounts-tab").removeClass("hidden");
  $("#container-outlay_company").html("");
}

function reloadCompaniesSelect(response) {
  $(".nav.nav-inline.navbar-user-dropdown").html(response.view);
  $("#selected_company")
    .select2({ width: "271px", height: "75%" })
    .addClass("form-control");
  addFormControlSelect2();
}

function loadOutlayDetails(data, element) {
  console.log(data);

  $.ajax({
    url: "/outlay/companies",
    data: $(this).serialize(),
    success: function(response) {
      let outlayIntegration = response.data;

      let select =
        '<select class="form-control select2-hidden-accessible" readonly="" id="outlay_company_id" name="outlay_company_id" tabindex="-1" aria-hidden="true"></select>';
      $("#container-outlay_company").html(select);
      let $outlaySelect = $("#outlay_company_id");
      let options =
        '<option value="">' +
        allLangFiles.companies.outlay.deselect +
        "</option>";

      $.each(outlayIntegration, function(key, value) {
        let selected =
          value.keepers !== null && value.keepers.id == data.id
            ? "selected"
            : "";
        let outlayName =
          value.outlay.vat !== ""
            ? value.outlay.id +
              ": " +
              value.outlay.name +
              " - " +
              value.outlay.vat
            : value.outlay.id + ": " + value.outlay.name;
        let name =
          selected === "" && value.keepers !== null
            ? outlayName + " (" + value.keepers.name + ")"
            : outlayName;

        options +=
          '<option value="' +
          value.outlay.id +
          '"' +
          selected +
          ">" +
          name +
          "</option>";
      });
      $outlaySelect.html(options);

      $outlaySelect
        .select2({
          width: "100%",
          height: "100%",
          dropdownParent: element,
        })
        .addClass("form-control");
    },
    error: fnErrorMsg,
  });
}
